// import React, { useState, useRef, useEffect } from "react";
// import { useInView } from "react-intersection-observer";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, Navigation, Autoplay } from "swiper";

// import example from "../../assets/video/example.mp4";
// import playButton from "../../assets/images/home/playButton.svg";
// import pauseButton from "../../assets/images/home/pauseButton.svg";
// import store from "../../assets/images/store/store.png";

// const StoreInAction = () => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [hasClickedPlay, setHasClickedPlay] = useState(false);
//   const [showPlayButton, setShowPlayButton] = useState(true);
//   const [activeVideoIndex, setActiveVideoIndex] = useState(0);

//   const videoSources = [example, example, example];

//   const videoRef = useRef(null);
//   const { ref: sectionRef, inView } = useInView({
//     threshold: 0.5
//   });

//   const handlePlayClick = async () => {
//     if (videoRef.current) {
//       if (!hasClickedPlay) {
//         setHasClickedPlay(true);
//         videoRef.current.muted = false;
//         videoRef.current.currentTime = 0;
//       }

//       try {
//         if (videoRef.current.paused || videoRef.current.ended) {
//           await videoRef.current.play();
//           setIsPlaying(true);
//           setShowPlayButton(false);
//         } else {
//           videoRef.current.pause();
//           setIsPlaying(false);
//           setShowPlayButton(true);
//         }
//       } catch (error) {
//         console.error("Playback failed:", error);
//       }
//     }
//   };

//   useEffect(() => {
//     if (videoRef.current && inView && !hasClickedPlay) {
//       videoRef.current.muted = true;
//       videoRef.current?.play();
//       setIsPlaying(true);
//       setShowPlayButton(true);
//     } else if (!inView && isPlaying) {
//       videoRef.current?.pause();
//       setIsPlaying(false);
//       setShowPlayButton(true);
//     }
//   }, [inView, hasClickedPlay, isPlaying]);

//   const handleSlideChange = (swiper) => {
//     setActiveVideoIndex(swiper.activeIndex);
//     setShowPlayButton(true);
//     setIsPlaying(false);
//     if (videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.currentTime = 0;
//     }
//   };

//   return (
//     <section className="neo" ref={sectionRef}>
//       <div className="container neoContainer storiesInAction">
//         <div className="common-heading">
//           <h1>Stories in Action</h1>
//         </div>
//         <div className="introducing" onClick={handlePlayClick}>
//           {!hasClickedPlay && !inView ? (
//             <img src={store} alt="Introducing Neo" />
//           ) : (
//             <video
//               ref={videoRef}
//               className="recipe"
//               width="100%"
//               loop
//               playsInline
//               preload="auto"
//               controls={false}
//               key={videoSources[activeVideoIndex]}
//             >
//               <source src={videoSources[activeVideoIndex]} />
//             </video>
//           )}

//           {showPlayButton && (
//             <img
//               src={playButton}
//               className="play"
//               alt="Play Button"
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "50%",
//                 transform: "translate(-50%, -50%)",
//                 cursor: "pointer",
//                 display: "block"
//               }}
//             />
//           )}

//           {!showPlayButton && (
//             <img
//               src={pauseButton}
//               className="play"
//               alt="Pause Button"
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "50%",
//                 transform: "translate(-50%, -50%)",
//                 cursor: "pointer",
//                 display: "block"
//               }}
//             />
//           )}

//           <div
//             className="storeActionSlider"
//             onClick={(event) => event.stopPropagation()}
//           >
//             <Swiper
//               modules={[Navigation, Pagination, Autoplay]}
//               spaceBetween={30}
//               slidesPerView={1}
//               onSlideChange={handleSlideChange}
//               navigation={{
//                 prevEl: ".custom-swiper-button-prevO",
//                 nextEl: ".custom-swiper-button-nextT"
//               }}
//               pagination={{
//                 clickable: true,
//                 renderBullet: (index, className) => `
//                   <div class="${className} custom-bullet">
//                     <div class="progress-bar"></div>
//                   </div>`
//               }}
//               autoplay={{ delay: 3000, disableOnInteraction: false }}
//               loop
//             >
//               <SwiperSlide>
//                 <div className="storeContent">
//                   Stay engaged without the worry of writing things down.
//                 </div>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <div className="storeContent">
//                   Focus on the conversation, we&aposve got the notes covered!
//                 </div>
//               </SwiperSlide>
//               <SwiperSlide>
//                 <div className="storeContent">
//                   Never miss a moment. Your thoughts, perfectly captured.
//                 </div>
//               </SwiperSlide>

//               <div className="custom-swiper-button-prevO"></div>
//               <div className="custom-swiper-button-nextT"></div>
//             </Swiper>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default StoreInAction;

import React, { useRef } from "react";

import getEmotional from "../../assets/video/storeInAction/getEmotionalInsights.MP4";
import getUnbiased from "../../assets/video/storeInAction/getUnbiased.MP4";
import neverForget from "../../assets/video/storeInAction/neverForgetAnything.MP4";
import askNeoAnything from "../../assets/video/storeInAction/askNeoAnything.MP4";

import adventures from "../../assets/images/home/adventures.png";
import smartDining from "../../assets/images/home/smartDining.png";
import boundaries from "../../assets/images/home/boundaries.png";

import "./storeInAction.scss";
import Button from "component/Button/Button";
import FadeUp from "component/FadeUp/FadeUp";
import useScreenMobile from "hooks/useScreenMobile";

import { analytics } from "../../firebase";
import { logEvent } from "firebase/analytics";

const cardData = [
  {
    id: 1,
    videoSrc: getEmotional,
    imgSrc: smartDining,
    description: "Read Between The Lines"
  },
  {
    id: 2,
    videoSrc: getUnbiased,
    imgSrc: adventures,
    description: "Own Every Moment"
  },
  {
    id: 3,
    videoSrc: neverForget,
    imgSrc: boundaries,
    description: "Never Forget Anything"
  },
  {
    id: 4,
    videoSrc: askNeoAnything,
    imgSrc: boundaries,
    description: "Seal With Confidence"
  }
];

const StoreInAction = () => {
  const videoRefs = useRef(cardData.map(() => React.createRef()));
  const isMobile = useScreenMobile({ size: 678 });

  return (
    <section className="container storeContainer common-padding">
      <div className="common-heading">
        <FadeUp>
          <h1 className="storeHeading">Built To Make You Superhuman</h1>
        </FadeUp>
      </div>

      <div className="storeInActionCard">
        {cardData.map((card, index) => (
          <div className="storeCard" key={card.id}>
            <div className="storeVideoBox">
              <video
                className="storeVideo "
                loop
                muted
                autoPlay
                playsInline
                preload="auto"
                ref={(el) => (videoRefs.current[index] = el)}
              >
                <source src={card.videoSrc} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <FadeUp>
              <p className="storeVideoContent">{card.description}</p>
            </FadeUp>
          </div>
        ))}
      </div>
      <div className="storeBuyNow">
        <Button
          title="Order Now"
          onClick={() => {
            logEvent(analytics, "order_now_storeInAction");
            window.location.href = "https://shop.neosapien.xyz";
          }}
          fontsize={isMobile ? "16px" : "20px"}
          padding={isMobile ? "13px 30px" : " 15px 30px"}
        />
      </div>
    </section>
  );
};

export default StoreInAction;
